import {buildItemPickerSearchUrl} from '@github-ui/item-picker-base/api/urls'
import {IssueMultiSelectFieldPickerFieldServerQuery} from '@github-ui/server-persisted-queries'
import type {IssueMultiSelectFieldPickerFieldServerQueryQuery} from '@github-ui/server-persisted-queries/types/IssueMultiSelectFieldPickerFieldServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

type IssueMultiSelectFieldPickerNode = NonNullable<IssueMultiSelectFieldPickerFieldServerQueryQuery['node']>
type IssueMultiSelectFieldPickerNodeWithOptions = Extract<IssueMultiSelectFieldPickerNode, {options: unknown}>

export type IssueMultiSelectFieldPickerServerOption = IssueMultiSelectFieldPickerNodeWithOptions['options'][number]

export function issueMultiSelectFieldPickerOptionsQueryKey(fieldId: string) {
  return ['item-picker', 'issue-multi-select-field-options', {fieldId}] as const
}

export async function fetchIssueMultiSelectFieldPickerOptions(
  fieldId: string,
  signal?: AbortSignal,
): Promise<readonly IssueMultiSelectFieldPickerServerOption[]> {
  const requestUrl = buildItemPickerSearchUrl('issue_multi_select_field_options', {
    id: fieldId,
    queryId: IssueMultiSelectFieldPickerFieldServerQuery,
  })
  const response = await reactFetchJSON(requestUrl, {signal})

  if (!response.ok) throw new Error(`Issue multi-select field options fetch failed (${response.status})`)

  const json = (await response.json()) as {
    data?: IssueMultiSelectFieldPickerFieldServerQueryQuery
    errors?: unknown[]
  }
  if (json.errors?.length || !json.data) throw new Error('Issue multi-select field options query returned errors')

  const node = json.data.node
  if (node && 'options' in node) return node.options ?? []
  return []
}
